import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const Logout: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M2.88 3.88A3 3 0 0 1 5 3h7a3 3 0 0 1 3 3v2a1 1 0 0 1-2 0V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-2a1 1 0 0 1 2 0v2a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 .88-2.12Zm14.41 4.41a1 1 0 0 1 1.42 0l3 3a1 1 0 0 1 0 1.42l-3 3a1 1 0 0 1-1.42-1.42l1.3-1.29H9a1 1 0 0 1 0-2h9.59l-1.3-1.29a1 1 0 0 1 0-1.42Z" />
  </Icon>
);

export default Logout;
